import { triplaServer } from 'src/apis/server'
import { serialize } from 'object-to-formdata'

const isTrackMetricsEnabled = process.env.ENABLE_CDP_TRACK_METRICS === 'true'

export function getSegmentedIconMessages(hotelId) {
  return triplaServer
    .get('api/triplabot/v1/cdp/icon_messages', {
      params: {
        hotel_id: hotelId
      }
    })
    .then((res) => res.data.data)
}

export default {
  getSegmentedIconMessages,
  createMetrics(metrics) {
    if (!isTrackMetricsEnabled) return Promise.resolve()

    return triplaServer.post(
      'api/triplabot/v1/cdp/chatbot_metrics',
      serialize({
        chatbot_metrics: metrics
      })
    )
  }
}
